module.exports = __webpack_public_path__ + "static/media/white-logo.67e48eb8.png";